import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function AssistWalkerIcon(props: IconProps) {
    return <Icon {...props} iconKey={"assist_walker"}/>
}
